import { ServiceErrorHandler } from "@TaankYou/services";


const SUBCODES = {
    
};

const errorsHandler = e => ServiceErrorHandler(e, {
    
});

export { errorsHandler, SUBCODES };



// WEBPACK FOOTER //
// ./src/services/InvoiceV2/errors.js